import React, { Component, Fragment } from 'react';
import ReturnPageHeader from "pages/returnCheckout/ReturnPageHeader" 
//ELEM REACT16 CHANGE
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextAre, Table} from "semantic-ui-react"
import shop from "shop/shop"
import Responsive from "react-responsive"
import ContactMessage from 'components/Messages/ContactMessage';
import LocalFooter from 'components/LocalFooter';

class ReturnPageContact extends Component {
    state = {
        glnNumber: '',
        saison: ''
    };

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        console.log(this.state);
    }

    componentDidMount() {
        if(!shop.delivery){
          console.log("shop.delivery is empty")
          this.props.history.push("/return")
        }
      }

    render() {
        if(!shop.delivery){
            console.log("shop.delivery is empty")
            this.props.history.push("/return")
            document.location.reload()
            return null
        }
        return (
            <Fragment>
                <Responsive minWidth={790}>
                <div>
                <Table>
                <colgroup>
                    <col width="10%" />
                    <col width="12%" />
                    <col width="3%" />
                    <col width="55%" />
                </colgroup>
                <tbody>
                    <tr>
                    <td>
                            &nbsp;
                        </td>
                        <td className="pr4  pl4 v-top ReturnPageAlignment" >
                            <ReturnPageHeader className="pt7" activeStep={3} />
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td className="pr4  pl4 v-top ReturnPageAlignment" >
                        <h1 style={{color:"#917236", fontSize:40}}  className="pt5 tl"><b>Kontakt</b></h1>
                            {/*<div style={{width:"70%"}}>
                            <p>Sollten sich Fragen ergeben, rufen Sie bitte unter folgender Nummer an: (Restantennhotline)

                            Tel.: 0241/ 8881-0

                            Grüße vom goldenen Hasen mit Glocke!</p>
        </div>*/}
                            <Message style={{width: "80%"}}>
                            <ContactMessage />
                            </Message>
                        </td>
                    </tr>
                    </tbody>
                </Table>
            </div>
                </Responsive>
                <Responsive maxWidth={789}>
                <table>
                <colgroup>
                    <col width="90%" />
                </colgroup>
                <tbody>
                    <tr className="bb b--black-10">
                        <td>
                        <div className="headerInline"><Button style={{backgroundColor: "#ffffff", maxWidth:"55px"}} 
                            onClick={() => (this.state.navHeader ? this.setState({navHeader : false}) : this.setState({navHeader : true}
                            ))}>
                                <Icon className="big bars tc" ></Icon>
                            </Button><span className="pt3 tc fw7 f2">Restanten</span></div>
                        {this.state.navHeader && <ReturnPageHeader className="v-top" activeStep={3} />}
                        </td>
                        </tr>
                        <tr>
                        <td className="tc pr2  pl2 v-top ReturnPageAlignment" >
                        <h1 style={{color:"#917236", fontSize:40}}  className="tc"><b>Kontakt</b></h1>
                        <Message >
                        <ContactMessage />
                            </Message>
                        </td>
                    </tr>
                    </tbody>
                </table>
                    </Responsive>
                    <LocalFooter/>
            </Fragment>
        );
    }
}

export default ReturnPageContact;


// WEBPACK FOOTER //
// ./src/theme/lindt/pages/returnCheckout/ReturnPageContact.js